export default {
  SET_MESSAGE: (state, message) => (state.message = message),
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_SUCCESS: (state, success) => (state.success = success),
  SET_LOGGED_IN: (state, loggedIn) => (state.loggedIn = loggedIn),
  RESET_ALL: (state) =>
    function () {
      state.message = "";
      state.errors = {};
    },
  SET_FORGET_PHONE: (state, phone) => (state.forget_phone = phone),
};
